// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"a36d11c9","93":"df40b1fc","106":"4aab4c36","111":"4ecbfc8e","131":"0f6988ae","133":"f3209f87","143":"bb858332","279":"560d70a2","292":"dcb7c555","419":"fdacebfe","479":"d9a9ab5b","495":"3a68e4cb","500":"c576aa21","624":"2b248e05","801":"502deb46","936":"e9116ae2"}[chunkId] + ".chunk.js";
};